import { gray, green } from "colorette";
import fetch from "node-fetch";
import semver from "semver";

import { logger } from "@/src/utils/logger.ts";

interface PackageInfo {
  name: string;
  version: string;
  "dist-tags": {
    latest: string;
  };
}

export const checkForUpdate = async (
  packageName: string,
  currentVersion: string,
) => {
  // Check npm registry for latest version
  try {
    const packageInfo = (await (
      await fetch(`https://registry.npmjs.org/${packageName}`)
    ).json()) as PackageInfo;

    const latestVersion = packageInfo["dist-tags"].latest;

    // Compare versions
    if (semver.gt(latestVersion, currentVersion)) {
      logger.break();
      logger.box(
        `Update available! ${gray(`v${currentVersion}`)} ≫ ${green(
          `v${latestVersion}`,
        )}
Run \`pnpm i -D zeytal@latest\` to update.`,
        { borderColor: "black" },
      );
    }
  } catch {
    // Silently fail if we can't check
  }
};
